module.exports = __webpack_public_path__ + "static/img/KHKGROUP.30d76f69.png";